<template>
  <div class="my-echarts">    
    <div ref="myChart" :class="chartClass"></div>
  </div>
</template>

<script>
  export default {
    props: {
        'chartClass' : {
            type: String,
            required: true,
        },
        'datasetDimensions': {
            type: Array,
            required: true
        },
        'datasetSource': {
            type: Array,
            required: true
        },
        'option': {
            type: Object,
            required: true
        },
    },    
    mounted () {
        this.initEchars();
    },
    data() {
        return {
            myChart: {},
            echarOption: {},
        }
    },
    methods: {
        initEchars(){
            let dom = this.$refs.myChart;
            this.myChart = echarts.init(dom);
            this.echarOption = {
                dataset: {
                    dimensions: this.datasetDimensions,
                    source: this.datasetSource,
                }
            }      
            _.extend(this.echarOption,this.option);

            this.myChart.setOption(this.echarOption, {
                notMerge : true
            });
        },
        chartChange () {
            this.initEchars();
        }
    }
  };
</script>

<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// CommonEchars.vue?287f965f